import { CfmService } from 'services/CfmService/CfmService';

import { formDynamicFormEvent } from 'stores/DynamicForm/FormDynamicFormEvents';
import formDynamicFormStore from 'stores/DynamicForm/FormDynamicFormStore';

const execute = async (crm: string, uf: string, index: number) => {
  const prev = formDynamicFormStore.getState().crmValidations;
  formDynamicFormEvent({
    crmValidations: { ...prev, [index]: { name: '', isLoading: true, isInvalid: false } },
  });

  try {
    const result = await CfmService.verifyUserIsValid(crm, uf);
    const isInvalid = result.hasError || !result.data;
    const name = result.data?.name ?? '';
    const current = formDynamicFormStore.getState().crmValidations;
    formDynamicFormEvent({
      crmValidations: { ...current, [index]: { name, isLoading: false, isInvalid } },
    });
    return { name, isInvalid };
  } catch {
    const current = formDynamicFormStore.getState().crmValidations;
    formDynamicFormEvent({
      crmValidations: { ...current, [index]: { name: '', isLoading: false, isInvalid: true } },
    });
    return { name: '', isInvalid: true };
  }
};

export const verifyCfmUseCase = { execute };
